export const REFERRAL_EVENT_MESSAGE_NAME = {
  FLAG_REFERRAL: "Flag Referral",
};

//We can refactor later on for the REFERRAL_ACTIONS to include Flag Referral

export const NEW_STATE = "New";
export const SENT_STATE = "Sent";
export const SEND_FAILED_STATE = "Send Failed";
export const IN_REVIEW_STATE = "In review";
export const SCHEDULED_STATE = "Scheduled";
export const CONSULTED_STATE = "Consulted";
export const DONE_STATE = "Done";
export const CLOSED_STATE = "Closed";
export const DECLINED_STATE = "Declined";

const SEND_REFERRAL_MESSAGE = "Send Referral";
const MOVE_REFERRAL_TO_REVIEW_MESSAGE = "Move Referral to Review";
const MOVE_REFERRAL_TO_SCHEDULED_MESSAGE = "Move Referral to Scheduled";
const REVERSE_IN_REVIEW_MESSAGE = "Reverse In Review";
const MOVE_REFERRAL_TO_CONSULTED_MESSAGE = "Move Referral to Consulted";
const REVERSE_SCHEDULED_MESSAGE = "Reverse Scheduled";
const MOVE_REFERRAL_TO_DONE_MESSAGE = "Move Referral to Done";
const REVERSE_CONSULTED_MESSAGE = "Reverse Consulted";
const CLOSE_REFERRAL_MESSAGE = "Close Referral";
const CANCEL_REFERRAL_MESSAGE = "Cancel Referral";
const REJECT_REFERRAL_MESSAGE = "Reject Referral";
const ACCEPT_REFERRAL_MESSAGE = "Accept Referral";
const SCHEDULING_STATE = "Scheduling";
const REVERSE_SCHEDULING_MESSAGE = "Reverse Scheduling";

export const REFERRAL_ACTIONS = {
  SENT: [
    { status: NEW_STATE, message: SEND_REFERRAL_MESSAGE, target: SENT_STATE },
    {
      status: SEND_FAILED_STATE,
      message: SEND_REFERRAL_MESSAGE,
      target: SENT_STATE,
    },
    {
      status: SENT_STATE,
      message: MOVE_REFERRAL_TO_REVIEW_MESSAGE,
      target: IN_REVIEW_STATE,
    },
    {
      status: IN_REVIEW_STATE,
      message: MOVE_REFERRAL_TO_SCHEDULED_MESSAGE,
      target: SCHEDULED_STATE,
    },
    {
      status: SCHEDULED_STATE,
      message: REVERSE_IN_REVIEW_MESSAGE,
      target: IN_REVIEW_STATE,
    },
    {
      status: SCHEDULED_STATE,
      message: MOVE_REFERRAL_TO_CONSULTED_MESSAGE,
      target: CONSULTED_STATE,
    },
    {
      status: CONSULTED_STATE,
      message: REVERSE_SCHEDULED_MESSAGE,
      target: SCHEDULED_STATE,
    },
    {
      status: CONSULTED_STATE,
      message: MOVE_REFERRAL_TO_DONE_MESSAGE,
      target: DONE_STATE,
    },
    {
      status: DONE_STATE,
      message: REVERSE_CONSULTED_MESSAGE,
      target: CONSULTED_STATE,
    },
    {
      status: DONE_STATE,
      message: CLOSE_REFERRAL_MESSAGE,
      target: CLOSED_STATE,
    },
    {
      status: [NEW_STATE, SENT_STATE, IN_REVIEW_STATE, SCHEDULED_STATE],
      message: CANCEL_REFERRAL_MESSAGE,
      target: DONE_STATE,
    },
    {
      status: [IN_REVIEW_STATE, SCHEDULED_STATE],
      message: REJECT_REFERRAL_MESSAGE,
      target: DECLINED_STATE,
    },
    {
      status: DECLINED_STATE,
      message: CLOSE_REFERRAL_MESSAGE,
      target: CLOSED_STATE,
    },
  ],
  RECEIVED: [
    {
      status: NEW_STATE,
      message: MOVE_REFERRAL_TO_REVIEW_MESSAGE,
      target: IN_REVIEW_STATE,
    },
    {
      status: IN_REVIEW_STATE,
      message: ACCEPT_REFERRAL_MESSAGE,
      target: SCHEDULING_STATE,
    },
    {
      status: SCHEDULING_STATE,
      message: REVERSE_IN_REVIEW_MESSAGE,
      target: IN_REVIEW_STATE,
    },
    {
      status: SCHEDULING_STATE,
      message: MOVE_REFERRAL_TO_SCHEDULED_MESSAGE,
      target: SCHEDULED_STATE,
    },
    {
      status: SCHEDULED_STATE,
      message: REVERSE_SCHEDULING_MESSAGE,
      target: SCHEDULING_STATE,
    },
    {
      status: SCHEDULED_STATE,
      message: MOVE_REFERRAL_TO_CONSULTED_MESSAGE,
      target: CONSULTED_STATE,
    },
    {
      status: CONSULTED_STATE,
      message: REVERSE_SCHEDULED_MESSAGE,
      target: SCHEDULED_STATE,
    },
    {
      status: CONSULTED_STATE,
      message: MOVE_REFERRAL_TO_DONE_MESSAGE,
      target: DONE_STATE,
    },
    {
      status: DONE_STATE,
      message: REVERSE_CONSULTED_MESSAGE,
      target: CONSULTED_STATE,
    },
    {
      status: DONE_STATE,
      message: CLOSE_REFERRAL_MESSAGE,
      target: CLOSED_STATE,
    },
    {
      status: [NEW_STATE, IN_REVIEW_STATE, SCHEDULING_STATE, SCHEDULED_STATE],
      message: CANCEL_REFERRAL_MESSAGE,
      target: DONE_STATE,
    },
    {
      status: [NEW_STATE, IN_REVIEW_STATE, SCHEDULING_STATE, SCHEDULED_STATE],
      message: REJECT_REFERRAL_MESSAGE,
      target: DECLINED_STATE,
    },
    {
      status: DECLINED_STATE,
      message: CLOSE_REFERRAL_MESSAGE,
      target: CLOSED_STATE,
    },
  ],
};
